import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "autocloser"];

  connect() {
  }

  openDialog(e) {
    this.dialogTarget.showModal();
  }

  closeFromBackdropDialog(e) {
    if (e.type == "mousedown" && e.target == this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  close() {
    this.dialogTarget.close();
  }

  autocloserTargetConnected(element) {
    setTimeout(() => {
      this.close()
    }, 2000);
  }
}
